module.exports = __webpack_public_path__ + "img/167.fd09a2ed.jpg";